module.exports = __webpack_public_path__ + "img/icon_baseInfo.ca31cc59.png";